import { SvgIcon } from '@mui/material';
import { Component } from 'react';

export default class LogoPJeSimboloBranco extends Component {
    render() {
        return (
            <SvgIcon
                viewBox="0 0 132.56 82.7"
                preserveAspectRatio="xMidYMid meet"
                {...this.props}
            >
                <path
                    fill="#feffff"
                    d="M59.11,33.8c0,6.84-4,13.49-13.24,13.49H36.28V55.7a6.67,6.67,0,0,1-6.67,6.67h-.77V23.2a2.88,2.88,0,0,1,2.88-2.89H45.87c9.28,0,13.24,6.78,13.24,13.49m-7.44,0c0-3.3-1.71-6.84-6-6.84H36.28V40.58H45.5c4.4,0,6.17-3.36,6.17-6.78"
                />
                <path
                    fill="#feffff"
                    d="M51.67,60h0a5.27,5.27,0,0,1,5.26-4.7h0c4.34,0,6-3.11,6-6.84V27.76a7.45,7.45,0,0,1,7.45-7.45v28.1c0,7.51-3.6,14-13.43,14a21.7,21.7,0,0,1-3.87-.52A1.78,1.78,0,0,1,51.67,60"
                />
                <path
                    fill="#c7c6c6"
                    d="M103.54,41.88h-22c.8,4,3.85,6,8.06,6a10.15,10.15,0,0,0,6.25-2,2.84,2.84,0,0,1,3.48,0,3.22,3.22,0,0,1,.08,5,16.22,16.22,0,0,1-10.18,3.38c-8.54,0-15-6-15-14.9,0-9.09,6.83-14.83,14.95-14.83s14.59,5.68,14.59,14.59a24.38,24.38,0,0,1-.18,2.75m-6.9-5c-.43-3.9-3.42-6.16-7.39-6.16s-6.89,1.83-7.75,6.16Z"
                />
            </SvgIcon>
        );
    }
}
